import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { selectComplianceEnabled, selectHasAnyTaskManagementBp } from 'features/auth/ducks/selectors'
import ComplianceInactiveNotice from 'features/dashboard/sections/ComplianceInactiveNotice'

const ComplianceGuard = ({ children }) => {
  const complianceEnabled = useSelector(selectComplianceEnabled)
  const hasAnyTaskManagementBp = useSelector(selectHasAnyTaskManagementBp)
  if (!complianceEnabled || !hasAnyTaskManagementBp) {
    return (
      <Wrap>
        <ComplianceInactiveNotice />
      </Wrap>
    )
  }
  return children
}

export default ComplianceGuard

const Wrap = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 24px;
  box-sizing: border-box;
`
